import * as React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import {
  ResponsePlanDecoration,
  PayloadPlanDecoration,
  Proposal
} from "src/redux/projects";
import { Loader } from "./Loader";
import { CurrentResponse } from "src/redux/currentResponses";
interface Props {
  response: CurrentResponse | undefined;
  isLocked: boolean;
  proposal: Proposal;
  loader: boolean;
  handleChangeArtwork: (ressourceId) => void;
  handleSubmitProposalPending: (
    payload: PayloadPlanDecoration,
    response: ResponsePlanDecoration | undefined
  ) => void;
  handleSubmitProposalValidated: (
    payload: PayloadPlanDecoration,
    currentReponse: ResponsePlanDecoration | undefined
  ) => void;
  handleChangeRessourcePlanDecoration: (
    ressourceId: number,
    response: ResponsePlanDecoration
  ) => void;
  step: number;
  currentId: number;
  onChangeStep: (step: number) => void;
}
type PropsWithNamespaces = Props & WithNamespaces;

interface State {
  cgv: boolean;
  comment: string;
  lastVersionTransmitted: boolean;
}
class PlanDecorationSidebar extends React.Component<
  PropsWithNamespaces,
  State
> {
  state: State = {
    cgv: false,
    comment: this.props.proposal.responses[0].payload
      ? this.props.proposal.responses[0].payload.comment
      : "",
    lastVersionTransmitted: false
  };
  handleSubmit = e => {
    e.preventDefault();
    const payload: PayloadPlanDecoration = {
      cgv: this.state.cgv,
      comment: this.state.comment,
      lastVersionTransmitted: this.state.lastVersionTransmitted
    };
    this.props.handleSubmitProposalPending(
      payload,
      this.props.response &&
        (this.props.response.response as ResponsePlanDecoration)
    );
  };
  handleSubmitValidated = e => {
    e.preventDefault();
    const payload: PayloadPlanDecoration = {
      cgv: this.state.cgv,
      comment: this.state.comment,
      lastVersionTransmitted: this.state.lastVersionTransmitted
    };
    this.props.handleSubmitProposalValidated(
      payload,
      this.props.response &&
        (this.props.response.response as ResponsePlanDecoration)
    );
  };
  onCgvChange = e => {
    this.setState({ cgv: e.target.checked });
  };
  onLastVersionTransmittedChange = e => {
    this.setState({ lastVersionTransmitted: e.target.checked });
  };
  onCommentChange = e => {
    this.setState({ comment: e.target.value });
  };

  render() {
    const comment = this.props.proposal.responses[0].payload
      ? this.props.proposal.responses[0].payload.comment
      : "";

    const currentRessource = this.props.proposal.ressources.find(
      r => r.id === this.props.currentId + 1
    );
    return (
      <div className="sidebar-right">
        <div
          className={`step step-end ${this.props.step === 1 ? "active" : ""}`}
        >
          <div className="sidebar-right-infos">
            <p className="title">
              {this.props.t("proposal.deco.validation.title", {
                title: this.props.proposal.ressources[this.props.currentId]
                  .label
              })}
            </p>
          </div>
          <div className="sidebar-right-items flex-column d-flex">
            <div className="flex-1 sidebar-right-items-item p-3 flex-column">
              <div className="d-flex flex-column mb-4">
                <p className="mb-1">
                  {this.props.t("proposal.deco.validation.globalComment")}
                </p>
                <textarea
                  onChange={this.onCommentChange}
                  value={this.state.comment}
                  placeholder="..."
                />
              </div>
            </div>
            <div className="p-3">
              <div className="d-flex align-items-center mb-3">
                <label className="checkbox-custom container-checkbox">
                  <input
                    type="checkbox"
                    name="cgv"
                    onChange={this.onCgvChange}
                    checked={this.state.cgv}
                  />
                  <span className="checkmark" />
                </label>
                <small className="pl-2">
                  {this.props.t("proposal.deco.validation.cgv")}
                </small>
              </div>
              <div className="d-flex align-items-center mb-2">
                <label className="checkbox-custom container-checkbox">
                  <input
                    type="checkbox"
                    name="lastVersionTransmitted"
                    onChange={this.onLastVersionTransmittedChange}
                    checked={this.state.lastVersionTransmitted}
                  />
                  <span className="checkmark" />
                </label>
                <small className="pl-2">
                  {this.props.t(
                    "proposal.deco.validation.lastVersionTransmitted"
                  )}
                </small>
              </div>
            </div>
          </div>
          <div className="m-auto text-center w-100">
            <button
              onClick={e => this.props.onChangeStep(0)}
              className="btn text-underline btn-transparent"
              style={{ textDecoration: "underline" }}
            >
              {this.props.t("proposal.btnBack")}
            </button>
            <button
              className="btn btn-primary mb-0"
              onClick={this.handleSubmit}
            >
              {!this.props.loader && (
                <div>
                  {this.props.t("button.saveAndWait")}
                  <img
                    className="ml-1"
                    src="assets/svgs/right-chevron-white.svg"
                    width="10px"
                  />
                </div>
              )}
              {this.props.loader && <Loader />}
            </button>
            <button
              disabled={!(this.state.lastVersionTransmitted && this.state.cgv)}
              className="btn btn-primary"
              onClick={this.handleSubmitValidated}
            >
              {!this.props.loader && (
                <div>
                  {this.props.t("button.validAndSend")}
                  <img
                    className="ml-1"
                    src="assets/svgs/right-chevron-white.svg"
                    width="10px"
                  />
                </div>
              )}
              {this.props.loader && <Loader />}
            </button>
          </div>
        </div>
        <div
          className={`step step-start ${this.props.step === 0 ? "active" : ""}`}
        >
          <div className="sidebar-right-infos">
            <p className="title">
              {this.props.t("proposal.deco.selection.title")}
            </p>
          </div>
          <div className="sidebar-right-items">
            {this.props.isLocked &&
              this.props.proposal.ressources[this.props.currentId] && (
                <div className="sidebar-right-items-item current">
                  <label className="m-auto">
                    <img
                      className="vignette"
                      width="150px"
                      src={
                        this.props.proposal.ressources[this.props.currentId]
                          .thumb
                      }
                    />
                    <p
                      style={{
                        backgroundColor:
                          currentRessource && currentRessource.payload
                            ? currentRessource.payload.color
                            : "",
                        color: "#fff"
                      }}
                      className="label font-weight-bold "
                    >
                      {
                        this.props.proposal.ressources[this.props.currentId]
                          .label
                      }
                    </p>
                  </label>
                </div>
              )}
            {!this.props.isLocked &&
              this.props.proposal.ressources.map((r, index) => (
                <div
                  key={r.id}
                  className={`sidebar-right-items-item ${
                    this.props.currentId === index ? "current" : ""
                  }`}
                >
                  <label className="m-auto" htmlFor={`artwork-${r.id}`}>
                    <img className="vignette" width="150px" src={r.thumb} />
                    <input
                      onChange={e => this.props.handleChangeArtwork(index)}
                      checked={this.props.currentId === index}
                      type="radio"
                      name="ressource"
                      id={`artwork-${r.id}`}
                      className="d-none"
                    />
                    <p
                      style={{
                        backgroundColor: r.payload ? r.payload.color : "",
                        color: "#fff"
                      }}
                      className="label font-weight-bold "
                    >
                      {r.label}
                    </p>
                  </label>
                </div>
              ))}
          </div>

          <div className="m-auto text-center w-100">
            {!this.props.isLocked && (
              <button
                className="btn btn-primary"
                onClick={e => this.props.onChangeStep(1)}
              >
                {this.props.t("proposal.deco.selection.btn")}
                <img
                  className="ml-1"
                  src="assets/svgs/right-chevron-white.svg"
                  width="10px"
                />
              </button>
            )}
            {this.props.isLocked && comment && (
              <div className="p-4">{comment}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default withNamespaces()(PlanDecorationSidebar);



// WEBPACK FOOTER //
// ./src/components/PlanDecorationSidebar.tsx